import { render, staticRenderFns } from "./CompanyGeneralDetails.vue?vue&type=template&id=7579f798&"
import script from "./CompanyGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyGeneralDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports